import { create } from 'zustand/react';

import { createFilterListsSlice, FilterListsSlice } from 'hooks/state/FilterListsSlice';
import { createFilterSetsSlice, FilterSetsSlice } from 'components/filter/advancedFilter/hooks/useFilterSetsStore';
import {
  createDisabledFiltersSlice,
  createHiddenFiltersSlice,
  DisabledFiltersSlice,
  HiddenFiltersSlice,
} from 'hooks/state/DisabledFiltersSlice';

export const useTransitiveCacheStore = create<
  FilterListsSlice & FilterSetsSlice & DisabledFiltersSlice & HiddenFiltersSlice
>()((...a) => ({
  ...createFilterListsSlice(...a),
  ...createFilterSetsSlice(...a),
  ...createDisabledFiltersSlice(...a),
  ...createHiddenFiltersSlice(...a),
}));
